import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-relation",
  "use": "icon-relation-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol viewBox=\"0 0 128 128\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-relation\">\r\n  <!-- 左侧药片 -->\r\n  <rect x=\"16\" y=\"24\" width=\"32\" height=\"64\" rx=\"16\" fill=\"currentColor\" />\r\n  <rect x=\"16\" y=\"24\" width=\"32\" height=\"32\" rx=\"16\" fill=\"white\" opacity=\"0.4\" />\r\n  <!-- 右侧药片 -->\r\n  <rect x=\"80\" y=\"40\" width=\"32\" height=\"64\" rx=\"16\" fill=\"currentColor\" />\r\n  <rect x=\"80\" y=\"72\" width=\"32\" height=\"32\" rx=\"16\" fill=\"white\" opacity=\"0.4\" />\r\n  <!-- 连接线 -->\r\n  <path d=\"M48 56 L80 72\" stroke=\"currentColor\" stroke-width=\"6\" stroke-linecap=\"round\" fill=\"none\" />\r\n  <!-- 连接节点 -->\r\n  <circle cx=\"48\" cy=\"56\" r=\"6\" fill=\"currentColor\" />\r\n  <circle cx=\"80\" cy=\"72\" r=\"6\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/relation.svg
// module id = b2wR
// module chunks = 72